import { createApp, watch } from 'vue'
import axios from 'axios'
import router from './router'
import App from './App'
import Toast from './plugins/toast'
import i18n from './i18n'

// CSS imports
import './assets/css/theme.css'
import './assets/sass/enigma.scss'

// Axios config
axios.defaults.baseURL = 'https://api.gigahost.no/api/v0/'

const app = createApp(App)
app.use(router)
app.use(Toast)
app.use(i18n)

watch(() => i18n.global.locale, (lang) => {
  document.documentElement.setAttribute('lang', lang === 'no' ? 'nb' : 'en')
  document.title = 'Gigahost - ' + i18n.global.t('report.page_title')
}, { immediate: true })

// Global properties
app.config.globalProperties.$http = axios

app.mount('#app')
